export default {
  path: '/goods-item',
  meta: {
    title: '',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/goods-item`),
}



// WEBPACK FOOTER //
// ./src/views/GoodsItem/router.js